


















































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";

@Component
export default class Header extends Mixins(Loading, tablePagination) {
  @Prop() fromDate!: string;
  @Prop() shopName!: string;
  @Prop() phone!: string;
  @Prop() userName!: string;
  @Prop() enterCost!: number;
}
